// extracted by mini-css-extract-plugin
module.exports = {"container":"GroupStatusBadge_container__2Qwy5","closedBadge":"GroupStatusBadge_closedBadge__1kWuu","activeBadge":"GroupStatusBadge_activeBadge__W0JgM"};